<template>
    <div class="mr-3 min-h-full">
        <div class="pt-0 sticky sticky-top top-0 bg-white z-10" :class="search?'h-20':'h-12'">
            <div class="relative cursor-pointer rounded-lg bg-gray-100 mt-0 mb-2 block">
                <div class="flex items-center justify-between px-3 py-1 text-left w-full">
                    <div class="flex w-full items-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="vue-feather text-gray-400 feather feather-search"
                        >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <textarea
                            type="text"
                            autocomplete="off"
                            class="mx-1 py-1.5 px-1.5 font-bold text-gray-600 border-none border-transparent resize-none outline-none shadow-none ring-0 bg-transparent text-sm mb-0 w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:z-10 focus:z-20"
                            name="search"
                            v-model="search"
                            @keydown.esc.prevent.stop="search='';applySearch()"
                            @keydown.enter.prevent.stop="next();"
                            @input="applySearch"
                            placeholder="Search..."
                            :style="'box-shadow:none !important'"
                            rows="1"
                        ></textarea>
                        <span class="text-gray-500 fa fa-times pl-1 hover:text-blue-500" v-if="search"
                              @click="search=''"></span>
                    </div>
                </div>
            </div>
            <div class="text-xs text-gray-500 w-full flex justify-end" v-if="search">
                <span class="mx-2">Viewing: <span class="text-brand"
                                                  v-html="matchedMessages.indexOf(currentMessage)+1"></span> of <span
                    class="text-brand" v-html="matchedMessages.length"></span> results</span>
                <span class="font-semibold hover:text-brand mx-1" @click="previous()">
                    <i class="fas fa-arrow-up"></i>
                </span>
                <span class="font-semibold hover:text-brand mx-1" @click="next()">
                        <i class="fas fa-arrow-down"></i>
                </span>
            </div>
        </div>
        <main ref="chatcontainer" class="ml-2 mr-1 flex flex-col pt-2 " :style="'padding-bottom:'+height+'px'">
            <div class="m-2 mb-4 flex justify-center border-b" v-if="!showAll && (this.messages.length>25)">
                <span class="text-xs text-gray-400 pb-1 hover:text-brand" @click="showAll = true;">
                    <span class="fa fa-arrow-up"></span><span class="ml-2">Show {{ this.messages.length - 25 }} more messages...</span>
                </span>
            </div>
            <message-widget-message v-for="(message,index) in readMessages"
                                    :key="index+'|'+message.id"
                                    :ref="'message'+message.id"
                                    :contacts="contacts"
                                    :channel="channel"
                                    :highlight="search"
                                    :user="user"
                                    @replyingTo="setReplyingTo"
                                    @viewEmail="viewEmail"
                                    @messageClicked="gotoMessage"
                                    :message="message"></message-widget-message>
            <div class="m-2 mb-4 flex justify-center border-b"
                 v-if="this.channel.firstUnreadMessageId && this.messages.length">
                <span class="text-xs text-gray-400 pb-1">
                    <span class="fa fa-arrow-down"></span><span class="ml-2">Unread messages</span>
                </span>
            </div>
            <message-widget-message v-for="(message,index) in unreadMessages"
                                    :key="index+'|'+message.id"
                                    :ref="'message'+message.id"
                                    :contacts="contacts"
                                    :channel="channel"
                                    :highlight="search"
                                    @replyingTo="setReplyingTo"
                                    @viewEmail="viewEmail"
                                    @messageClicked="gotoMessage"
                                    :user="user"
                                    :message="message"></message-widget-message>
        </main>
        <aside class="my-0 pt-1 pb-0 mb-3 mx-0 bottom-1 fixed z-10" ref="messeger"
               :style="'width:'+width +'px'">
            <div v-if="(channel.source === user.id) && (channel.type === 'DIRECT')" class="mb-2">
                <span class="text-brand font-semibold">This is your space.</span>
                Draft messages, list your to-dos, etc. You can also talk to yourself here, but please bear in mind
                you’ll have to supply both sides of the conversation.
            </div>
            <div class="rounded-lg bg-gray-50 mx-0 p-2 border border-gray-200">
                <div v-if="replyingTo">
                    <div class="flex">
                        <div class="text-xs font-semibold flex-grow">Replying to:</div>
                        <div class="flex-shrink pl-2"><i class="fa fa-times text-gray-400 opacity-50 hover:opacity-100"
                                                         @click="setReplyingTo(false)"/></div>
                    </div>
                    <message-widget-quoted :message="replyingTo"></message-widget-quoted>
                </div>
                <div class="mt-1 flex rounded-md shadow-none">
                    <div class="shadow-sm flex flex-grow">
                        <div class="relative flex items-stretch flex-grow focus-within:z-10">
                            <autoresizable-textarea ref="autoresizable-textarea">
                        <textarea
                            v-model="newMessage"
                            rows="1"
                            class="focus:ring-brand focus:border-brand block w-full mb-0 rounded-none rounded-l-md pl-3 sm:text-sm border-gray-300"
                            placeholder="Enter message here..."
                            :class="this.sendDisabled?'bg-gray-200':''"
                            type="text"
                            :ref="'messagebox'"
                            :disabled="this.sendDisabled"
                            @keydown.enter="sendFromEnter"
                            @keydown.esc.stop.prevent="() => {if (newMessage ===''){ close() } else { newMessage = ''; setDraft();}}"
                            @input="() => {setDraft();debouncedSetTyping();}"
                        ></textarea>
                            </autoresizable-textarea>
                        </div>
                        <button
                            class="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
                            @click.prevent="sendMessage()" :disabled="this.sendDisabled"
                            :class="this.sendDisabled?'text-gray-500 bg-gray-200':'text-gray-700 bg-gray-50 hover:bg-gray-100'">
                            <i class="fas fa-caret-right"></i>
                            <span>Send</span>
                        </button>
                    </div>
                    <div v-if="!this.sendDisabled"
                         class="-ml-px relative inline-flex items-end space-x-2 px-4 py-1 shadow-none outline-none border-none text-sm font-medium focus:outline-none hover:text-brand">
                        <ui-dropdown menu-class="px-4 py-2 w-56" :placement="'bottom'">
                            <template #default="{ toggle, open, close}">
                                <button class="flex-1 mb-2" @click="open">
                                    <i class="fa fa-ellipsis-h w-1"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item
                                    icon="fas fa-link"
                                    @click="addLink(); close()"
                                    v-text="'Add Link to Current Page'">
                                </ui-dropdown-item>
                                <ui-dropdown-divider v-if="channel.type === 'GROUP'"></ui-dropdown-divider>
                                <ui-dropdown-item
                                    icon="fas fa-att-out-alt"
                                    @click="() => {leaveGroup(); close()}"
                                    v-if="channel.type === 'GROUP'"
                                    v-text="'Leave Group'">
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <div class="w-full text-gray-500 text-xs ml-1 mt-3 mb-0 cursor-default"
                     v-if="attachments.length"
                >
                    <span>Attachments:</span>
                    <a v-for="attachment in attachments"
                       class="text-gray-500 hover:text-gray-500 border rounded border-gray-300 bg-gray-50 font-bold px-2 py-0.5 inline-block cursor-default ml-1 my-0.5"
                       :href="'#'">
                        <template v-if="attachment.type ==='DEFECT'">
                            <i class="fas fa-fragile mr-1"></i>
                            <span v-text="attachment.name"></span>
                            <span class="text-gray-400 fa fa-times pl-1 hover:text-blue-500"
                                  @click="removeAttachment(attachment)"></span>
                        </template>
                        <template v-else-if="attachment.type ==='LINK'">
                            <i class="fas fa-link mr-1"></i>
                            <span v-text="attachment.title"></span>
                            <span class="text-gray-400 fa fa-times pl-1 hover:text-blue-500"
                                  @click="removeAttachment(attachment)"></span>
                        </template>
                    </a>
                </div>
            </div>
        </aside>

    </div>
</template>

<script>

import Slideover from "../../slideovers/Slideover.vue";
import moment from "moment-timezone";
import {Message} from "@models";
import PageCell from "../../ui/PageCell.vue";
import AutoresizableInput from "../../ui/AutoresizableInput";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import MessageWidgetChannelAvatars from "./MessageWidgetChannelAvatars.vue";
import MessageWidgetUserAvatar from "./MessageWidgetUserAvatar.vue";
import {uuid} from "../../../utils";
import {cloneDeep, debounce} from "lodash";
import remoteStorage from "../../../utils/remoteStorage";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import MessageWidgetMessage from "./MessageWidgetMessage.vue";
import MessageWidgetQuoted from "./MessageWidgetQuoted.vue";

export default {
    components: {
        MessageWidgetQuoted,
        MessageWidgetMessage,
        UiDropdownDivider,
        MessageWidgetUserAvatar,
        MessageWidgetChannelAvatars,
        UiDropdownItem, UiDropdown, AutoresizableTextarea, AutoresizableInput, PageCell, Slideover
    },
    props: {
        user: Object,
        channel: Object,
        contacts: [],
        attachment: null,
        parentElement: HTMLDivElement,
        scrollContainer: HTMLDivElement,
    },
    data() {
        let drafts = remoteStorage.getItem('messageDrafts', {}, true);
        let attachments = this.attachment ? [this.attachment] : (drafts[this.channel.source] ? drafts[this.channel.source].a : []);
        return {
            search: '',
            moment,
            messages: [],
            newMessage: this.attachment ? this.attachment.message : (drafts[this.channel.source] ? drafts[this.channel.source].m : ''),
            attachments: (attachments && attachments.length) ? attachments : [],
            width: '410',
            height: '44',
            sendDisabled: false,
            showAll: false,
            messageDrafts: drafts,
            debouncedUpdateMessageDrafts: debounce(() => remoteStorage.setItem('messageDrafts', JSON.stringify(this.messageDrafts)), 500),
            debouncedSetTyping: debounce(() => this.setTyping(), 1500, {leading: true, maxWait: 3000}),
            offsets: {},
            matchedMessages: [],
            currentMessage: false,
            flashTimout: false,
            replyingTo: (drafts[this.channel.source] ? drafts[this.channel.source].r : null),
        }
    },
    computed: {
        viewMessages() {
            if (this.showAll) {
                return this.messages;
            }
            return this.messages.slice(-25)
        },
        readMessages() {
            let messages = this.viewMessages;
            let index = messages.findIndex((i) => i.id === this.channel.firstUnreadMessageId)
            if (index !== -1) {
                return messages.slice(0, index);
            } else {
                return messages;
            }
        },
        unreadMessages() {
            let messages = this.viewMessages;
            let index = messages.findIndex((i) => i.id === this.channel.firstUnreadMessageId)
            if (index !== -1) {
                return messages.slice(index);
            }
            return [];
        }
    },
    methods: {
        gotoMessage(e) {
            if (!this.showAll) {
                this.showAll = true
                this.$nextTick(() => {
                    this.recalcOffsets();
                    this.gotoMessage(e);
                })
                return;
            }
            this.matchedMessages = [e]
            this.scrollTo(e)
        },
        async viewEmail(e) {
            let message = await Message.find(this.channel.id, e.id, true);
            this.$modals.open('message-widget-email', {
                email: message.email
            })
        },
        setReplyingTo(e) {
            if (e) {
                this.replyingTo = {message: e.message, id: e.id, from: e.from};
                this.$refs.messagebox.focus();
            } else {
                this.replyingTo = null;
            }
            this.setDraft()
            this.$nextTick(() => {
                this.setDimensions();
            })
        },
        applySearch() {
            this.recalcOffsets()
            if (this.search.trim() !== '') {
                if (!this.showAll) {
                    this.showAll = true
                    this.$nextTick(() => {
                        this.applySearch()
                    })
                    return;
                }
                let target = this.scrollContainer.scrollTop + ((this.scrollContainer.getBoundingClientRect().height + 50) / 2);
                let closeness = 999999999;
                let messageId = false;
                let search = this.search.trim().toLowerCase();
                let messagesOfInterest = this.messages.filter((message) => {
                    return message.message.toLowerCase().includes(search) || message.attachments.some((a) => a.title && a.title.toLowerCase().includes(search))
                })
                this.matchedMessages = messagesOfInterest.map((m) => m.id);
                messagesOfInterest.forEach((message) => {
                    let offset = this.offsets[message.id];
                    let c = Math.abs(offset - target);
                    if (c < closeness) {
                        closeness = c
                        messageId = message.id
                    }
                })
                this.scrollTo(messageId)
            }
        },
        previous() {
            let p = this.matchedMessages.indexOf(this.currentMessage)
            if (p !== -1) {
                if (p === 0) {
                    this.scrollTo(this.matchedMessages[this.matchedMessages.length - 1])
                } else {
                    this.scrollTo(this.matchedMessages[p - 1])
                }
            }
        },
        next() {
            if (this.search.trim()) {
                let p = this.matchedMessages.indexOf(this.currentMessage)
                if (p !== -1) {
                    if (p + 1 === this.matchedMessages.length) {
                        this.scrollTo(this.matchedMessages[0])
                    } else {
                        this.scrollTo(this.matchedMessages[p + 1])
                    }
                    this.focusOnSearch()
                }
            }
        },
        addLink() {
            let w = window;
            w = w.parent ? w.parent : w;
            let title = w.document.getElementsByTagName("title")[0].text;
            this.attachments.push({title: title, 'type': 'LINK', 'url': w.location.href})
            this.setDraft();
        },
        removeAttachment(attachment) {
            this.attachments = this.attachments.filter((i) => i !== attachment)
            this.setDraft()
        },
        setTyping() {
            User.push('userTyping', {sourceId: this.channel.sourceId})
        },
        setDraft() {
            if (this.newMessage) {
                this.messageDrafts[this.channel.source] = {
                    'm': this.newMessage,
                    'r': this.replyingTo,
                    'd': moment(),
                    'a': this.attachments
                }
            } else {
                delete this.messageDrafts[this.channel.source];
            }
            this.debouncedUpdateMessageDrafts()
            this.$nextTick(() => this.setDimensions())
        },
        async leaveGroup() {
            if (this.sendDisabled) return;
            this.sendDisabled = true
            this.newMessage = ''
            this.replyingTo = null
            this.setDraft()
            await Message.removeFromGroup(this.channel.source, this.user.id)
        },
        close() {
            this.$emit('close', false);
            this.messages = [];
        },
        sendFromEnter(e) {
            if (!e.ctrlKey && !e.shiftKey && !e.metaKey && !e.altKey) {
                e.preventDefault()
                this.sendMessage()
            }
        },
        async sendMessage() {
            if (this.sendDisabled) return;
            this.channel.firstUnreadMessageId = false;
            let message = this.newMessage;
            if (message || (this.attachments && this.attachments.length)) {
                this.sendDisabled = true;
                this.$nextTick(() => {
                    this.$refs["autoresizable-textarea"].resizeTextarea()
                })
                let id = uuid();
                this.messages.push({
                    'fromId': this.user.id,
                    'from': this.user.name,
                    'id': id,
                    'statusLogs': [],
                    'message': message,
                    'replyTo': this.replyingTo,
                    'attachments': this.attachments ? cloneDeep(this.attachments) : [],
                    'createdAt': moment(),
                    'createdAtFormatted': moment().format('lll')
                })
                this.scrollToBottom()
                await Message.send(this.channel, message, id, this.replyingTo ? this.replyingTo.id : null, this.attachments.length ? this.attachments : [])
                this.newMessage = ''
                this.replyingTo = null
                this.attachments = [];
                this.setDraft();
                this.$emit('messageSent')
                this.sendDisabled = false;
                this.$nextTick(() => {
                    this.$refs["autoresizable-textarea"].resizeTextarea()
                    this.focusOnMessage();
                })
                this.debouncedSetTyping.cancel();
                User.push('userFinishedTyping')
            }
        },
        scrollToBottom: function () {
            this.$emit('scrollToBottom')
        },
        focusOnSearch() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    if (this.$refs.searchbox) {
                        this.$refs.searchbox.focus()
                    }
                })
            })
        },
        focusOnMessage() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    if (this.$refs["messagebox"]) {
                        this.$refs["messagebox"].focus()
                    }
                })
            })
        },
        setDimensions() {
            if (this.$el) {
                if (!this.$refs.messeger) {
                    setTimeout(() => this.setDimensions(), 50);
                    return;
                }
                if (this.parentElement) {
                    this.width = Math.floor(this.parentElement.getBoundingClientRect().width) - 12;
                } else {
                    this.width = Math.floor(this.$el.getBoundingClientRect().width)
                }
                let height = this.$refs.messeger.getBoundingClientRect().height;
                let diff = height - this.height
                this.height = height;
                if (diff > 0) {
                    this.$nextTick(() => eventBus.$emit('slideover-scroll', diff));
                }
            } else {
                this.$nextTick(() => {
                    this.setDimensions();
                })
            }
        },
        recalcOffsets() {
            this.offsets = {};
            this.messages.forEach((message) => {
                let el = this.$refs["message" + message.id]
                if (el) {
                    this.offsets[message.id] = this.scrollContainer.scrollTop + el[0].$el.getBoundingClientRect().top;
                }
            })
        },
        flasher(messageId) {
            if (this.$refs['message' + messageId][0]) {
                this.$refs['message' + messageId][0].$el.classList.remove('animate-highlight')
                setTimeout(() => {
                    this.$refs['message' + messageId][0].$el.classList.add('animate-highlight')
                }, 50)
            }
        },
        scrollTo(messageId) {
            if (messageId) {
                this.currentMessage = messageId
                this.$nextTick(() => {
                    if (this.$refs['message' + messageId]) {
                        let offset = (this.scrollContainer.getBoundingClientRect().height + 50) / 2
                        this.scrollContainer.scrollTop = this.offsets[messageId] - offset;
                        this.$nextTick(() => this.flasher(messageId))
                    } else {
                        if (!this.showAll) {
                            this.showAll = true
                            this.$nextTick(() => {
                                this.setDimensions()
                                this.recalcOffsets()
                                this.scrollTo(messageId)
                            })
                        } else {
                            setTimeout(() => this.scrollTo(messageId), 50)
                        }
                    }
                })
            }
        },
        async updateMessagesFromEvent(data) {
            await this.updateMessages()
            this.focusOnMessage()
        },
        async updateMessages() {
            if (this.channel.id) {
                let newMessages = await Message.all(this.channel.id)
                newMessages.forEach((message) => {
                    let original = this.messages.find((i) => i.id === message.id)
                    if (original) {
                        Object.assign(original, message)
                    } else {
                        this.messages.push(message)
                    }
                })
            } else {
                this.messages = [];
            }
            this.sendDisabled = !(!this.channel.id || this.channel.members.find((i) => (i.id === this.user.id) && i.active))
            this.$nextTick(() => {
                this.setDimensions()
                this.scrollToBottom()
            })
        },
    },
    updated() {
    },
    async mounted() {
        if (this.parentElement) {
            this.width = Math.floor(this.parentElement.getBoundingClientRect().width) - 12;
        }
        if (this.channel.id) {
            this.messages = await Message.all(this.channel.id)
        } else {
            this.messages = [];
        }
        this.sendDisabled = !(!this.channel.id || this.channel.members.find((i) => (i.id === this.user.id) && i.active))

        if (this.attachment) {
            this.newMessage = this.attachment.message
        }
        this.$nextTick(() => {
            this.setDimensions()
            this.focusOnMessage()
            if (this.channel.messageId) {
                this.recalcOffsets();
                this.scrollTo(this.channel.messageId)
            } else {
                this.scrollToBottom()
            }

        })
        window.addEventListener('resize', this.setDimensions, true);
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.setDimensions)
        })
    },
}
</script>
